export const CONTACT_REQUEST_STARTED = 'CONTACT_REQUEST_STARTED';
export const CONTACT_REQUEST_SUCCESS = 'CONTACT_REQUEST_SUCCESS';
export const CONTACT_REPLACE_CONTACT = 'CONTACT_REPLACE_CONTACT';
export const CONTACT_UPDATE_REQUEST_STARTED = 'CONTACT_UPDATE_REQUEST_STARTED';
export const CONTACT_UPDATE_REQUEST_SUCCESS = 'CONTACT_UPDATE_REQUEST_SUCCESS';
export const CONTACT_RESET_STATE = 'CONTACT_RESET_STATE';
